module.exports = __webpack_public_path__ + "img/icon-lottery-black.969327f7.svg";